import { AfterViewChecked, ChangeDetectorRef, Component, NO_ERRORS_SCHEMA, HostListener, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { RouterOutlet } from '@angular/router';
import { Bovin, Client, MenuAccess, Utilisateur } from '@estel-numerique/galaclick-api';
import { Constantes } from '@services/util/constantes';
import { interval } from 'rxjs';
import { FicheAnimalComponent, FicheAnimalComponentData } from '../app/ficheanimal/ficheAnimalModal';
import { InstallationDetailsComponent, InstallationDetailsComponentData } from '../app/installation/installation.component';
import { BaseComponent } from './classes/extends';
import { ClientAdv, ItemMenu } from './classes/models';
import { UploadComponent } from './composants';
import { SpinnerComponent } from './composants/spinner/spinner';
import { DocumentEnvoisComponent, DocumentEnvoisComponentData } from './document/pages/document-envois/document-envois.component';
import { DocumentListeComponent } from './document/pages/document-liste/document-liste.component';
import { FicheClientDetailsComponent } from './ficheclient/pages/ficheclient-details/ficheclient-details.component';
import { MenuGalaComponent } from './menu/menu-gala.component';
import { RechClientComponent } from './rech-client/rech-client.component';
import { UtilisateurDetailsComponent } from './utilisateur/utilisateur-detail/utilisateur-detail.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [MenuGalaComponent, RouterOutlet, SpinnerComponent, NgClass, FormsModule, MatButton],
    // Éléments <links> utilisés comme conteneurs stylés
    schemas: [NO_ERRORS_SCHEMA]
})
export class AppComponent extends BaseComponent implements OnInit, AfterViewChecked {

    private cdRef = inject(ChangeDetectorRef);
    private dialog = inject(MatDialog);

    /** Libellé traduit d'une entrée de menu (vide si le code menu est inconnu) */
    private libelleMenu(menu: MenuAccess): string {
        const cle = Constantes.CodeMenu[menu.CODMENU] as string;
        return cle ? this.translate.instant(cle) : '';
    }

    public checkCreer(): boolean { return false; }

    //    public title: string = 'Galaclick';
    public titre = 'Galaclick';
    public btnCreerLabel = 'Créer';
    public codeModule: string = null; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public fCreer?(): void;
    public fUpload?(file: File): void;
    public fExporter?(): void;
    public fRechercher?(sVal: string): void;
    public fRetour?(): void;
    public fFicheAnimaleModifiee?(): void;
    protected valRecherche: string;
    private component: BaseComponent;

    //Menu
    protected menuItems: ItemMenu[] = [];
    protected menuCreer: ItemMenu;
    protected menuUpload: ItemMenu;
    protected menuMonCompte: ItemMenu;
    protected menuExporter: ItemMenu;
    protected menuExploitation: ItemMenu;
    @ViewChildren(MenuGalaComponent) public menus: QueryList<MenuGalaComponent>;

    private compSave: BaseComponent;
    private compHasChange = false;

    /** Prénom et nom de la personne incarnée si la session est incarnée, sinon null */
    protected get personneIncarnee(): string | null {
        const utilisateur = this.sessionUser;
        return utilisateur?.INCARNEPAR ? `${utilisateur.PRENOM ?? ''} ${(utilisateur.NOM ?? '').toUpperCase()}`.trim() : null;
    }

    protected bulleSuperviseurOuverte = false;

    /** Ferme la bulle du mode superviseur sur un clic en dehors d'elle */
    @HostListener('document:click', ['$event'])
    protected fermerBulleSuperviseur(event: Event) {
        if (this.bulleSuperviseurOuverte && !(event.target as HTMLElement).closest('.zone-superviseur')) {
            this.bulleSuperviseurOuverte = false;
        }
    }

    /** Abandonne la session incarnée sans terminer la session Keycloak : l'écran d'authentification rétablit la session du compte à l'origine */
    protected revenirAMonCompte() {
        this.clearCache();
        this.monitoServ.unsetUser();
        history.replaceState(null, '', '#' + Constantes.URLAUTH);
        location.reload();
    }

    constructor() {
        super();
        this.util.titre.subscribe((sTitre) => this.titre = sTitre);
        this.util.btnCreerLabel.subscribe((sBtnCreerLabel) => this.btnCreerLabel = sBtnCreerLabel);
        this.util.exporter.subscribe((fExporter) => this.fExporter = fExporter);
        this.util.openAnimal.subscribe(({ NUNATI, bloquerRenommage }) => this.openAnimal(NUNATI, bloquerRenommage));
        this.util.openInstall.subscribe((install) => this.openInstall(install));
        this.util.openUtilisateur.subscribe((user) => this.openUtilisateur(user));
        this.util.openFicheClient.subscribe((client) => this.openFicheClient(client));
        this.util.openExportDoc.subscribe(({ dateDoc, idClient, codeDocs, isEnvoi }) => this.openExportDocument(dateDoc, idClient, codeDocs, isEnvoi));
        this.util.initMethodAppComponent.subscribe((comp: BaseComponent) => this.initMethodAppComponent(comp));
        this.util.refreshMenuItem.subscribe(() => {
            this.setMenu();
        });
        this.util.videRecherche.subscribe(() => { this.valRecherche = ''; });
    }

    // Supprimer le comportement par défaut de la touche Entrée sur les boutons
    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: Event) {
        const keyboardEvent = event as KeyboardEvent;
        const target = keyboardEvent.target as HTMLElement;

        // Si le focus est sur un bouton
        if (target.tagName === 'BUTTON') {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    updateBtnDisplay(comp: BaseComponent) {
        if (comp.checkCreer() && comp.checkCreer() == true && comp.fClicCreer) {
            this.fCreer = () => comp.fClicCreer(this.component);
        } else {
            this.fCreer = undefined;
        }
    }

    // méthode chargé de savoir si notre composant dispose de la fonction fClicUpload
    // (si présent, ajoutera en haut a droit le bouton adéquat)
    updateBtnUpload(comp: BaseComponent) {
        if (comp.fClicUpload) {
            this.fUpload = (file) => comp.fClicUpload(file);
        } else {
            this.fUpload = undefined;
        }
    }
    // méthode appelé lors de la validation de la popup d'import
    public uploader(file: File) {
        this.compSave.fClicUpload(file);
    }

    componentAdded(comp: BaseComponent) {
        this.component = comp;
        this.titre = comp?.titre;
        this.btnCreerLabel = (comp?.btnCreerLabel) ? comp?.btnCreerLabel : this.translate.instant('CREATE');

        comp?.rightsVerified?.subscribe?.((data: BaseComponent) => {
            this.compSave = data;
            this.compHasChange = true;
        });

        if (comp?.checkExport?.() && comp?.checkExport?.() == true && comp?.fClicExporter) {
            this.fExporter = () => comp?.fClicExporter?.(this.component);
        } else {
            this.fExporter = undefined;
        }

        if (comp?.fBarreRechercher) {
            this.fRechercher = (sVal) => comp?.fBarreRechercher?.(this.component, sVal);
            this.util?.rechercher?.subscribe?.(() => { this.fRechercher?.(this.valRecherche); });
        } else {
            this.fRechercher = undefined;
        }

        if (comp?.checkRetour?.() && comp?.checkRetour?.() == true && comp?.fClicRetour) {
            this.fRetour = () => comp?.fClicRetour?.(this.component);
        } else {
            this.fRetour = undefined;
        }

        this.initMethodAppComponent?.(comp);

        this.sessionUser = this.getUserSession?.();
    }

    /**
     *  Initialise les methodes déclarées ce-dessous pour le component passé en parametre
     * (Pour le moment cela concerne les méthodes output des modal du appcomponent)
     * @param comp
     */
    initMethodAppComponent(comp: BaseComponent) {
        if (comp) {

            if (comp.fFicheAnimaleModifiee) {
                this.fFicheAnimaleModifiee = () => comp.fFicheAnimaleModifiee(this.component);
            } else {
                this.fFicheAnimaleModifiee = undefined;
            }
        }
    }

    openAnimal(nunati: string, bloquerRenommage?: boolean) {
        if (nunati) {
            const dialogRef = this.dialog.open(FicheAnimalComponent, {
                data: {
                    bovin: { NUNATI: nunati } as Bovin,
                    bloquerRenommage: bloquerRenommage
                } as FicheAnimalComponentData
            });
            dialogRef.componentInstance.ficheModifiee.subscribe(() => {
                this.fFicheAnimaleModifiee();
            });
        }
    }

    openInstall(client: ClientAdv) {
        if (client) {
            this.dialog.open(InstallationDetailsComponent, {
                data: {
                    client: client
                } as InstallationDetailsComponentData
            });
        }
    }

    openUtilisateur(user: Utilisateur) {
        if (user) {
            this.dialog.open(UtilisateurDetailsComponent, { data: user });
        }
    }

    openFicheClient(client: Client) {
        if (client) {
            this.dialog.open(FicheClientDetailsComponent, { data: client });
        }
    }

    openExportDocument(dateDoc: string, idClient: number, codeDocs: string[], isEnvoi: boolean) {
        if (idClient) {
            this.dialog.open(DocumentEnvoisComponent, {
                data: {
                    controle: {
                        dateDoc: dateDoc,
                        idClient: idClient,
                        codeDocs: codeDocs
                    },
                    envoi: isEnvoi
                } as DocumentEnvoisComponentData
            });
        }
    }

    ngAfterViewChecked() {
        if (this.compHasChange) {
            this.updateBtnDisplay(this.compSave);
            this.updateBtnUpload(this.compSave);
            this.compHasChange = false;
            this.cdRef.detectChanges();
        }
    }

    ngOnInit() {
        super.ngOnInit();
        //reload app - monitoring user
        const userSession = this.getUserSession();
        this.monitoServ.monitorUser(userSession);

        //Reconnexion, on reste connecté sur Galaclick toute la journée. On relance la connexion toute les 29 minutes
        interval(1000 * 60 * 29).subscribe(() => {
            console.info('reconnexion automatique');
            this.util.refreshToken().catch(e => console.error(e));
        });
    }


    /** Constitution du menu */
    public setMenu() {

        //test mis en place en urgence
        if (this.util.getUserSession() != null) {
            const idUser = this.util.getUserSession().USRID;
            this.util.superAdmin = (idUser === 2 || idUser === 209 || idUser === 247);
        }

        // Charge le user dans la classe Access pour gestion des menu et des droits
        this.ctrlAccess.setUtilisateur(this.getUserSession(), this.util.superAdmin);

        const tabMenu: MenuAccess[] = this.ctrlAccess.getMenuAccess();
        let oItem: ItemMenu;
        this.menuItems = [];
        // On recherche les menus ayant des sous-menus
        let parent = '|';
        for (const menu of tabMenu) {
            if (menu.IDPARENT > 0) {
                parent += menu.IDPARENT + '|';
            }
        }

        let sousMenu = false;

        for (const menu of tabMenu) {
            if (Constantes.CodeMenu[menu.CODMENU] != undefined && Constantes.CodeOption[menu.CODOPTION] != undefined
                && menu.COAFF == 1) {
                // on verifie si c'est le parent d'un sous menu ou un sous menu !
                if (parent.includes('|' + menu.IDOPTION + '|')) {
                    // On vient de créer un sous menu, il faut l'ajouter au menu principal !
                    if (sousMenu == true) {
                        this.menuItems.push(oItem);
                    }

                    // On bascule en création d'un sous-menu
                    sousMenu = true;

                    oItem = new ItemMenu(
                        this.libelleMenu(menu),
                        (menu.URL != null) ? menu.URL : (menu.FONCTION != null) ? '#' : '/',
                        (menu.ICON != null) ? menu.ICON : '',
                        this.ctrlAccess.ctrlAccessOK(Constantes.CodeOption[menu.CODOPTION] as string),
                        (menu.FONCTION != null) ? menu.FONCTION : ''
                    );
                } else if (menu.IDPARENT > 0 && sousMenu == true) { // C'est un sous menu du parent créé précédement
                    oItem.addItem(
                        new ItemMenu(
                            this.libelleMenu(menu),
                            (menu.URL != null) ? menu.URL : (menu.FONCTION != null) ? '#' : '/',
                            (menu.ICON != null) ? menu.ICON : '',
                            this.ctrlAccess.ctrlAccessOK(Constantes.CodeOption[menu.CODOPTION] as string),
                            (menu.FONCTION != null) ? menu.FONCTION : ''
                        )
                    );

                } else { // C'est un menu standard
                    // On vient de créer un sous menu, il faut l'ajouter au menu principal !
                    if (sousMenu == true) {
                        sousMenu = false;
                        this.menuItems.push(oItem);
                    }

                    this.menuItems.push(
                        new ItemMenu(
                            this.libelleMenu(menu),
                            (menu.URL != null) ? menu.URL : (menu.FONCTION != null) ? '#' : '/',
                            (menu.ICON != null) ? menu.ICON : '',
                            this.ctrlAccess.ctrlAccessOK(Constantes.CodeOption[menu.CODOPTION] as string),
                            (menu.FONCTION != null) ? menu.FONCTION : ''
                        )
                    );
                }
            }
        }

        // On vient de créer un sous menu mais on a terminé, il faut l'ajouter au menu principal !
        if (sousMenu == true) {
            sousMenu = false;
            this.menuItems.push(oItem);
        }
        this.menuCreer = new ItemMenu(null, null, 'fa fa-plus-circle', true);
        this.menuUpload = new ItemMenu(null, null, 'fa fa-cloud-upload-alt', true);
        this.menuExporter = new ItemMenu(null, null, 'fa fa-download', true);
        this.menuExploitation = new ItemMenu(null, null, 'fas fa-warehouse', true);
        this.menuMonCompte = new ItemMenu(null, null, 'fa fa-user-circle', true);
        this.menuMonCompte.subItems = [];
        this.menuMonCompte.subItems.push(new ItemMenu(this.translate.instant("MENU.MONCOMPTE"), null, null, true, 'FCTMONCOMPTE'));
        if (this.getUserSession()?.ROLESUP) {
            this.menuMonCompte.subItems.push(new ItemMenu(this.translate.instant("MENU.INCARNATION"), null, null, true, 'FCTINCARNATION'));
        }
        this.menuMonCompte.subItems.push(new ItemMenu(this.translate.instant("APROPOS"), null, null, true, 'APROPOS'));
        this.menuMonCompte.subItems.push(new ItemMenu(this.translate.instant("MENU.DISCONNECT"), null, null, true, 'DECO'));
    }
    protected menuOuvert(index: number) {
        this.menus.forEach((elem, idx) => {
            if (idx !== index) {
                elem.close();
            }
        });
    }
    protected closeAllMenu() {
        this.menus.forEach((elem) => {
            elem.close();
        });
    }

    protected clicLogo() {
        this.router.navigate(['/']).catch(e => this.util.fErreur(e));
    }

    protected clicUpload() {
        const dialogUpload = this.dialog.open(UploadComponent);
        dialogUpload.componentInstance.onUpload.subscribe((file) => {
            this.uploader(file);
        });
    }

    protected emptySearchInput() {
        this.util.fViderecherche();
        this.fRechercher('');

    }

    protected openRechercheDocs() {
        this.dialog.open(DocumentListeComponent);
    }

    protected fExploitation() {
        this.dialog.open(RechClientComponent);
    }

    /**
     * Verification de l'accès au module de recherche de documents
     */
    protected checkIfAccessDocs(hasRecherche: boolean) {
        if (this.hasAccesModule(Constantes.CodeOption.CDOCELEVEURS)) {
            if ((!hasRecherche && this.fRechercher == null) || hasRecherche) {
                return true;
            }
        }
        return false;
    }

}
